import React from "react";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  AlertState,
  SiteCameras,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { handleDeactivateCamera } from "./SiteAboutPageUtils/handleDeactivateCamera";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const DeactivateButton = ({
  selected,
  setSiteCameras,
  setAlertState,
  setSelected,
  setSyncNeeded,
  setBackdropLoadingScreenOn,
  setSiteInfo,
}: {
  selected: readonly string[];
  setSiteCameras: Dispatcher<SiteCameras>;
  setAlertState: Dispatcher<AlertState>;
  setSelected: Dispatcher<readonly string[]>;
  setSyncNeeded: Dispatcher<boolean>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setSiteInfo: Dispatcher<any>;
}) => {
  const text = (
    <>
      <CloseIcon fontSize="small" />
      &nbsp;DEACTIVATE
    </>
  );
  const submittedObject = {
    camera_ids: selected,
  };
  const navigate = useNavigate();
  return (
    <OrangeTextButton
      disabled={!selected[0]}
      onClick={() => {
        setBackdropLoadingScreenOn(true);
        handleDeactivateCamera(
          submittedObject,
          navigate,
          setSiteCameras,
          setAlertState,
          setSelected,
          setSyncNeeded,
          setBackdropLoadingScreenOn,
          setSiteInfo
        );
      }}
      text={text}
    />
  );
};
